export const requestTypes = {
  post: {
    value: 0,
    name: '下单',
    tagType: 'primary',
  },
  check: {
    value: 1,
    name: '查单',
    tagType: 'info',
  },
  close: {
    value: 2,
    name: '关单',
    tagType: 'warning',
  },
  applyRefund: {
    value: 3,
    name: '申请退款',
    tagType: 'danger',
  },
  checkRefund: {
    value: 4,
    name: '查询退款',
    tagType: 'info',
  },
  applyGetOrder: {
    value: 5,
    name: '申请交易账单',
    tagType: 'primary',
  },
  applyGetFundOrder: {
    value: 6,
    name: '申请资金账单',
    tagType: 'primary',
  },
};

export function findRequestType(requestTypeValue) {
  for (const key in requestTypes) {
    if (requestTypeValue === requestTypes[key].value) return [requestTypes[key]];
  }
}
